'use strict';

var DeleteRoleController = function DeleteRoleController($scope, deleteRoleService, userManagementConstants) {
  $scope.mode = 'user-management-roles-mode';
  $scope.gridId = 'user-management-roles';
  $scope.roleExists = false;
  $scope.deleteRole = function () {
    return deleteRoleService.deleteRole($scope.roleName).then(function () {
      $scope.roleExists = false;
      $scope.$emit('user-management-manage-users:change-screen', userManagementConstants.SCREEN_VALUE.MANAGE_USERS);
    });
  };
};
DeleteRoleController.$inject = ['$scope', 'DeleteRoleService', 'UserManagementConstants'];
module.exports = DeleteRoleController;